import mobileImgKasko from '../assets/slider_mobile/casco.jpeg';
import mobileImgKaskoDark from '../assets/slider_mobile/dark/casco_ru.png';
import mobileImgTravel from '../assets/slider_mobile/travel.jpeg';
import mobileImgTravelDark from '../assets/slider_mobile/dark/abroad_ru.png';
import mobileImgProperty from '../assets/slider_mobile/property.jpeg';
import mobileImgPropertyDark from '../assets/slider_mobile/dark/property_ru.png';
import mobileImgHealth from '../assets/slider_mobile/health.jpeg';
import mobileImgHealthDark from '../assets/slider_mobile/dark/health_ru.png';
import mobileImgOgpo from '../assets/slider_mobile/ogpo.jpeg';
import mobileImgOgpoDark from '../assets/slider_mobile/dark/ogpo_ru.png';
import mobileImgKaskoKZ from '../assets/slider_mobile/kz/KZ_casco.jpg';
import mobileImgKaskoDarkKZ from '../assets/slider_mobile/dark/casco_kz.png';
import mobileImgTravelKZ from '../assets/slider_mobile/kz/KZ_travel.jpg';
import mobileImgTravelDarkKZ from '../assets/slider_mobile/dark/abroad_kz.png';
import mobileImgPropertyKZ from '../assets/slider_mobile/kz/KZ_property.png';
import mobileImgPropertyDarkKZ from '../assets/slider_mobile/dark/property_kz.png';
import mobileImgHealthKZ from '../assets/slider_mobile/kz/KZ_health.png';
import mobileImgHealthDarkKZ from '../assets/slider_mobile/dark/health_kz.png';
import mobileImgOgpoKZ from '../assets/slider_mobile/kz/KZ_ogpo.png';
import mobileImgOgpoDarkKZ from '../assets/slider_mobile/dark/ogpo_kz.png';
import mobileImgKaskoEN from '../assets/slider_mobile/en/ENG_casco.jpg';
import mobileImgKaskoDarkEN from '../assets/slider_mobile/dark/casco_en.png';
import mobileImgTravelEN from '../assets/slider_mobile/en/ENG_travel.png';
import mobileImgTravelDarkEN from '../assets/slider_mobile/dark/abroad_en.png';
import mobileImgPropertyEN from '../assets/slider_mobile/en/ENG_property.png';
import mobileImgPropertyDarkEN from '../assets/slider_mobile/dark/property_en.png';
import mobileImgHealthEN from '../assets/slider_mobile/en/ENG_health.png';
import mobileImgHealthDarkEN from '../assets/slider_mobile/dark/health_en.png';
import mobileImgOgpoEN from '../assets/slider_mobile/en/ENG_ogpo.jpg';
import mobileImgOgpoDarkEN from '../assets/slider_mobile/dark/ogpo_en.png';
import myFuelImg from '../assets/promotions/benzin.jpg';
import myGiftImg from '../assets/promotions/rozigriw.jpg';
import mySupportImg from '../assets/promotions/tehpomosh.jpg';
import myFuelImgKz from '../assets/promotions/kz/benzin.jpg';
import myGiftImgKz from '../assets/promotions/kz/rozigriw.jpg';
import mySupportImgKz from '../assets/promotions/kz/tehpomosh.jpg';
import myFuelImgEng from '../assets/promotions/eng/benzin.jpg';
import myGiftImgEng from '../assets/promotions/eng/rozigriw.jpg';
import mySupportImgEng from '../assets/promotions/eng/tehpomosh.jpg';
import myCheckupImg from '../assets/promotions/tehosmotr.png';
import myCheckupImgKz from '../assets/promotions/kz/tehosmotr_kz.png';
import myCheckupImgEng from '../assets/promotions/eng/tehosmotr_en.png';
import mobileCascoGift from '../assets/slider_mobile/kasko_gift_slider_mob_button_W_ru.png';
import mobileCascoGiftDark from '../assets/slider_mobile/dark/kasko_gift_slider_mob_button_B_ru.png';
import mobileCascoGiftKz from '../assets/slider_mobile/kz/kasko_gift_slider_mob_button_W_kz.png';
import mobileCascoGiftDarkKz from '../assets/slider_mobile/dark/kasko_gift_slider_mob_button_B_kz.png';
import mobileCascoGiftEng from '../assets/slider_mobile/en/kasko_gift_slider_mob_button_W_en.png';
import mobileCascoGiftDarkEng from '../assets/slider_mobile/dark/kasko_gift_slider_mob_button_B_en.png';

const assetsResources = {
  en: {
    assets: {
      mobileImgKasko:
        'https://api.jgarant.kz/admin/media/Site/Sliders/Kasko_mob_ru_W3_01.07.2025.webp',
      mobileImgTravel: mobileImgTravelEN,
      mobileImgProperty: mobileImgPropertyEN,
      mobileImgHealth: mobileImgHealthEN,
      mobileImgOgpo: mobileImgOgpoEN,
      mobileImgKaskoDark:
        'https://api.jgarant.kz/admin/media/Site/Sliders_dark/Kasko_mob_ru_B3_01.07.2025.webp',
      mobileImgTravelDark: mobileImgTravelDarkEN,
      mobileImgPropertyDark: mobileImgPropertyDarkEN,
      mobileImgHealthDark: mobileImgHealthDarkEN,
      mobileImgOgpoDark: mobileImgOgpoDarkEN,
      mobileDgpoAuto:
        'https://api.jgarant.kz/admin/media/Site/Sliders/DGPO_mob_en_W_.webp',
      mobileDgpoAutoDark:
        'https://api.jgarant.kz/admin/media/Site/Sliders_dark/DGPO_mob_en_B_.webp',
      mobileSupport:
        'https://api.jgarant.kz/admin/media/Site/Sliders/Call_center_mob_W_en%20(1).webp',
      mobileSupportDark:
        'https://api.jgarant.kz/admin/media/Site/Sliders_dark/Call_center_mob_B_en%20(1).webp',
      fuelImg: myFuelImgEng,
      giftImg: myGiftImgEng,
      supportImg: mySupportImgEng,
      checkupImg: myCheckupImgEng,
      mobileCascoGift: mobileCascoGiftEng,
      mobileCascoGiftDark: mobileCascoGiftDarkEng,
      mobileImgAbroadChemodan:
        'https://api.jgarant.kz/admin/media/Site/Sliders/mst_mobile_light_ru_26112025.webp',
      mobileImgAbroadChemodanDark:
        'https://api.jgarant.kz/admin/media/Site/Sliders_dark/mst_mobile_dark_ru_26112025.webp',
      mobileImgMedpul:
        'https://api.jgarant.kz/admin/media/Site/Sliders/medpul_mob_W_ru1.png',
      mobileImgMedpulDark:
        'https://api.jgarant.kz/admin/media/Site/Sliders_dark/medpul_mob_B_ru1.png',
      mobileCascoLimit:
        'https://api.jgarant.kz/admin/media/Site/Banners/Kasko_dtp_en_white.png',
      mobileCascoLimitDark:
        'https://api.jgarant.kz/admin/media/Site/Banners/%D0%9Aasko_dtp_en_black.png',
      cascoLimit:
        'https://api.jgarant.kz/admin/media/Site/Sliders/casco_mobile_light_ru_112025.webp',
      cascoLimitDark:
        'https://api.jgarant.kz/admin/media/Site/Sliders_dark/casco_mobile_dark_ru_112025.webp',
      mobileHappyNewYear:
        'https://api.jgarant.kz/admin/media/Site/Sliders/NY3_slider_mob_W_en.png',
      cascoKaspiRed:
        'https://api.jgarant.kz/admin/media/Site/Sliders/Kasko_KR_slider_mob_W_en.jpg',
      cascoKaspiRedDark:
        'https://api.jgarant.kz/admin/media/Site/Sliders_dark/Kasko_KR_slider_mob_B_en.jpg',
      criticalInsurance:
        'https://api.jgarant.kz/admin/media/Site/Sliders/mobile_light%20en.webp',
      criticalInsuranceDark:
        'https://api.jgarant.kz/admin/media/Site/Sliders_dark/mobile_dark%20en.webp',
      propertyPlus:
        'https://api.jgarant.kz/admin/media/Site/Sliders/property_plus_mobile_light%20en.webp',
      propertyPlusDark:
        'https://api.jgarant.kz/admin/media/Site/Sliders_dark/property_plus_mobile_dark%20en.webp',
    },
  },
  kz: {
    assets: {
      mobileImgKasko:
        'https://api.jgarant.kz/admin/media/Site/Sliders/Kasko_mob_kz_W3_01.07.2025.webp',
      mobileImgTravel: mobileImgTravelKZ,
      mobileImgProperty: mobileImgPropertyKZ,
      mobileImgHealth: mobileImgHealthKZ,
      mobileImgOgpo: mobileImgOgpoKZ,
      mobileImgKaskoDark:
        'https://api.jgarant.kz/admin/media/Site/Sliders_dark/Kasko_mob_kz_B3_01.07.2025.webp',
      mobileImgTravelDark: mobileImgTravelDarkKZ,
      mobileImgPropertyDark: mobileImgPropertyDarkKZ,
      mobileImgHealthDark: mobileImgHealthDarkKZ,
      mobileImgOgpoDark: mobileImgOgpoDarkKZ,
      mobileDgpoAuto:
        'https://api.jgarant.kz/admin/media/Site/Sliders/DGPO_mob_kz_W.webp',
      mobileDgpoAutoDark:
        'https://api.jgarant.kz/admin/media/Site/Sliders_dark/DGPO_mob_kz_B.webp',
      mobileSupport:
        'https://api.jgarant.kz/admin/media/Site/Sliders/Call_center_mob_W_kz%20(1).webp',
      mobileSupportDark:
        'https://api.jgarant.kz/admin/media/Site/Sliders_dark/Call_center_mob_B_kz%20(1).webp',
      fuelImg: myFuelImgKz,
      giftImg: myGiftImgKz,
      supportImg: mySupportImgKz,
      checkupImg: myCheckupImgKz,
      mobileCascoGift: mobileCascoGiftKz,
      mobileCascoGiftDark: mobileCascoGiftDarkKz,
      mobileImgAbroadChemodan:
        'https://api.jgarant.kz/admin/media/Site/Sliders/mst_mobile_light_kz_26112025.webp',
      mobileImgAbroadChemodanDark:
        'https://api.jgarant.kz/admin/media/Site/Sliders_dark/mst_mobile_dark_kz_26112025.webp',
      mobileImgMedpul:
        'https://api.jgarant.kz/admin/media/Site/Sliders/medpul_mob_W_kz1.png',
      mobileImgMedpulDark:
        'https://api.jgarant.kz/admin/media/Site/Sliders_dark/medpul_mob_B_kz1.png',
      mobileCascoLimit:
        'https://api.jgarant.kz/admin/media/Site/Banners/Kasko_dtp_kz_white.png',
      mobileCascoLimitDark:
        'https://api.jgarant.kz/admin/media/Site/Banners/Kasko_dtp_kz_black.png',
      cascoLimit:
        'https://api.jgarant.kz/admin/media/Site/Sliders/casco_mobile_light_kz_112025.webp',
      cascoLimitDark:
        'https://api.jgarant.kz/admin/media/Site/Sliders_dark/casco_mobile_dark_kz_112025.webp',
      mobileHappyNewYear:
        'https://api.jgarant.kz/admin/media/Site/Sliders/NY3_slider_mob_W_kz.png',
      cascoKaspiRed:
        'https://api.jgarant.kz/admin/media/Site/Sliders/Kasko_KR_slider_mob_W_kz.jpg',
      cascoKaspiRedDark:
        'https://api.jgarant.kz/admin/media/Site/Sliders_dark/Kasko_KR_slider_mob_B_kz.jpg',
      criticalInsurance:
        'https://api.jgarant.kz/admin/media/Site/Sliders/mobile_light%20kz.webp',
      criticalInsuranceDark:
        'https://api.jgarant.kz/admin/media/Site/Sliders_dark/mobile_dark%20kz.webp',
      propertyPlus:
        'https://api.jgarant.kz/admin/media/Site/Sliders/property_plus_mobile_light%20kz.webp',
      propertyPlusDark:
        'https://api.jgarant.kz/admin/media/Site/Sliders_dark/property_plus_mobile_dark%20kz.webp',
    },
  },
  ru: {
    assets: {
      mobileImgKasko:
        'https://api.jgarant.kz/admin/media/Site/Sliders/Kasko_mob_ru_W3_01.07.2025.webp',
      mobileImgTravel,
      mobileImgProperty,
      mobileImgHealth,
      mobileImgOgpo,
      mobileImgKaskoDark:
        'https://api.jgarant.kz/admin/media/Site/Sliders_dark/Kasko_mob_ru_B3_01.07.2025.webp',
      mobileImgTravelDark,
      mobileImgPropertyDark,
      mobileImgHealthDark,
      mobileImgOgpoDark,
      mobileDgpoAuto:
        'https://api.jgarant.kz/admin/media/Site/Sliders/DGPO_mob_ru_W.webp',
      mobileDgpoAutoDark:
        'https://api.jgarant.kz/admin/media/Site/Sliders_dark/DGPO_mob_ru_B.webp',
      mobileSupport:
        'https://api.jgarant.kz/admin/media/Site/Sliders/Call_center_mob_W_ru%20(1).webp',
      mobileSupportDark:
        'https://api.jgarant.kz/admin/media/Site/Sliders_dark/Call_center_mob_B_ru%20(1).webp',
      fuelImg: myFuelImg,
      giftImg: myGiftImg,
      supportImg: mySupportImg,
      checkupImg: myCheckupImg,
      mobileCascoGift,
      mobileCascoGiftDark,
      mobileImgAbroadChemodan:
        'https://api.jgarant.kz/admin/media/Site/Sliders/mst_mobile_light_ru_26112025.webp',
      mobileImgAbroadChemodanDark:
        'https://api.jgarant.kz/admin/media/Site/Sliders_dark/mst_mobile_dark_ru_26112025.webp',
      mobileImgMedpul:
        'https://api.jgarant.kz/admin/media/Site/Sliders/medpul_mob_W_ru1.png',
      mobileImgMedpulDark:
        'https://api.jgarant.kz/admin/media/Site/Sliders_dark/medpul_mob_B_ru1.png',
      mobileCascoLimit:
        'https://api.jgarant.kz/admin/media/Site/Banners/Kasko_dtp_ru_white.png',
      mobileCascoLimitDark:
        'https://api.jgarant.kz/admin/media/Site/Banners/Kasko_dtp_ru_black.png',
      cascoLimit:
        'https://api.jgarant.kz/admin/media/Site/Sliders/casco_mobile_light_ru_112025.webp',
      cascoLimitDark:
        'https://api.jgarant.kz/admin/media/Site/Sliders_dark/casco_mobile_dark_ru_112025.webp',
      mobileHappyNewYear:
        'https://api.jgarant.kz/admin/media/Site/Sliders/NY3_slider_mob_W_ru.png',
      cascoKaspiRed:
        'https://api.jgarant.kz/admin/media/Site/Sliders/Kasko_KR_slider_mob_W_ru.jpg',
      cascoKaspiRedDark:
        'https://api.jgarant.kz/admin/media/Site/Sliders_dark/Kasko_KR_slider_mob_B_ru.jpg',
      criticalInsurance:
        'https://api.jgarant.kz/admin/media/Site/Sliders/illness_mobile_light%20ru.webp',
      criticalInsuranceDark:
        'https://api.jgarant.kz/admin/media/Site/Sliders_dark/illness_mobile_dark%20ru.webp',
      propertyPlus:
        'https://api.jgarant.kz/admin/media/Site/Sliders/property_plus_mobile_light%20ru.webp',
      propertyPlusDark:
        'https://api.jgarant.kz/admin/media/Site/Sliders_dark/property_plus_mobile_dark%20ru.webp',
    },
  },
};

export default assetsResources;
